// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2k4Zy","filesListContainer":"PosDisputesFiles_filesListContainer__3ix1c","filesButton":"PosDisputesFiles_filesButton__119WC"};